/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

const readWebpage = async function (webpage) {
    const guid = webpage?.guid;
    const isPublished = webpage?.published_at !== null;
    const item = {
        guid,
        model: webpage?.model, // guid of content record
        nav_title: webpage?.nav_title,
        type: webpage?.layout, // layout
        slug: webpage?.slug,
        description: webpage?.description,
        path: webpage?.path,
        shortlink: webpage?.shortlink,
        created_at: webpage?.created_at,
        updated_at: webpage?.updated_at,
        created_by: webpage?.created_by,
        updated_by: webpage?.updated_by,
        icon: webpage?.icon,
        position: webpage?.position,
        published_at: webpage?.published_at,
        isPublished,
        parent: webpage?.parent,
        children: [],
    };
    if (webpage.children) {
        const children = webpage.children;
        if (children) {
            for (const childdata of children) {
                const child = await readWebpage(childdata);
                item.children.push(child);
            }
        }
    }
    return item;
};

const readWebpageNav = async function (webpage) {
    const guid = webpage.guid;
    const item = {
        guid,
        nav_title: webpage.nav_title,
        description: webpage.description,
        path: webpage.path,
        type: webpage.type, // layout
        position: webpage.position,
        children: [],
        parent: webpage.parent,
    };
    if (webpage.children) {
        const children = webpage.children;
        if (children) {
            for (const childdata of children) {
                const child = await readWebpageNav(childdata);
                item.children.push(child);
            }
        }
    }
    return item;
};

export { readWebpage, readWebpageNav };
